import { ProductHomePage } from "@/components/product/product-home-page";
import { useTranslation } from "react-i18next";
import { fetch_middleware } from "../api/middleware";

export default function HomePage({ pbs_list }) {
	// Hooks
	const { t } = useTranslation();

	const transKey = "pbs";
	return (
		<ProductHomePage
			product_list={pbs_list}
			show_progress_bar={true}
			show_description={false}
			trans_key={transKey}
		/>
	);
}

/**
 * @type {import('next').GetServerSideProps}
 */
export async function getServerSideProps({ req }) {
	const response = await fetch_middleware(req, "/pbs/");

	return {
		props: {
			pbs_list: await response.json(),
		},
	};
}
